export default __webpack_public_path__ + "static/persons-modal-light-mode-5e86305ecb18da3480b8727e52df58dc.png";